import * as React from 'react';
import classNames from 'classnames';

import './table-container.scss';

type Props = {
  children: React.ReactNode,
  isCollapsed?: boolean,
  className?: string
};

class TableContainer extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { children, className, isCollapsed } = this.props;

    const classes = classNames('table-container', className, {
      'table-container--collapsed': isCollapsed
    });

    return (
      <section className={classes}>
        {children}
      </section>
    );
  }
}

export default TableContainer;
